import DOM from './dom';
import _ from './underscore';

class HTTPLoader {

    /**
     * Represent the cgp loading class.
     */
    static DIRECTIVE = '.cgp-loading.cgp-external-link-loader';

    /**
     * Hide loading spinner.
     */
    hide(): void {

        let elem = DOM.$$(HTTPLoader.DIRECTIVE);
        if (_.isNull(elem)) {
            return;
        }

        if (_.isArray(elem)) {
            elem.forEach((el) => {
               DOM.hide(el);
            });
        } else {
            DOM.hide(elem);
        }
    }


    /**
     * Show loading spinner.
     */
    show() : void {

        let elem = DOM.$$(HTTPLoader.DIRECTIVE);
        if (_.isNull(elem)) {
            return;
        }

        if (_.isArray(elem)) {
            elem.forEach((el) => {
                DOM.show(el);
            });
        } else {
            DOM.show(elem);
        }
    }
}

export default new HTTPLoader();